import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Icon from 'components/Icon';
import CloseButton from 'components/CustomButtons/CloseButton';
import { closeModalPage, openModalPage } from 'actions/modalPage';
import { modalPages as mp } from 'constants/modalPage';
import { getDefaultCustomer } from 'reducers/customerSearch';
import { getCanEditCustomers } from 'reducers/Login';
import { getSetting } from 'reducers/configs/settings';
import { getIsCardBoardingEnabled } from 'reducers/cafaConfigs';
import { PluginComponent } from 'plugins';

const Icons = ({ customer }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('customer');
  const isCardBoardingEnabled = useSelector(getIsCardBoardingEnabled);

  const storeCreditShouldBeHidden = !!useSelector(
    getSetting('pos_hide_add_credit_store_from_customer_view'),
  );

  const defaultCustomer = useSelector(getDefaultCustomer);
  const isDefaultCustomer = customer.id === defaultCustomer.id;
  const editCustomerRights = useSelector(getCanEditCustomers);
  const icons = [
    {
      name: 'icon_creditcard',
      title: t('mountCardsModal.mountCardsIcon'),
      id: 'mount-cards',
      hidden: !isCardBoardingEnabled,
      action: () => {
        dispatch(
          openModalPage({
            // @ts-ignore
            isPopup: false,
            component: mp.MountUnmountCard,
            props: {
              name: 'MountUnmountCard',
              props: customer,
            },
          }),
        );
      },
    },
    {
      name: 'icon_currency',
      title: t('customerView.buttons.addCredit'),
      id: 'add-credit',
      hidden: isDefaultCustomer || storeCreditShouldBeHidden,
      action: () => {
        dispatch(
          openModalPage({
            component: mp.storeCredit,
            props: { customer },
          }),
        );
      },
    },
    {
      name: 'icon_pencil-edit',
      title: t('customerView.buttons.editProfile'),
      id: 'edit-customer',
      hidden: isDefaultCustomer || Number(editCustomerRights) === 0,
      action: () => {
        dispatch(
          openModalPage({
            component: mp.createCustomer,
            groupID: mp.createCustomer,
            props: { customer },
          }),
        );
      },
    },
  ];

  const displayIcons = () =>
    icons
      .filter(i => !i.hidden)
      .map(icon => {
        const style = { paddingLeft: '12px', paddingRight: '12px' };
        return (
          <Icon
            style={style}
            key={icon.name}
            name={icon.name}
            title={icon.title}
            action={icon.action}
            data-testid={icon.id}
          />
        );
      });

  return (
    <PluginComponent hookname="UICustomerViewIcons" props={{ customer }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
        data-testid="customer-view-icons-container"
      >
        <>{displayIcons()}</>
        <CloseButton
          key="customer-view-close"
          action={() => dispatch(closeModalPage())}
        />
      </div>
    </PluginComponent>
  );
};

export default Icons;
